import { useEffect } from "react";
import { useDispatch } from 'react-redux';
import FileHeader from "./top/file_header";
import Headers from "./headers"
import Body from "./body"
import { updatePropertyForAll } from "../context/fileReducer";
import { comments } from "../common/statics";

const DrawFile = () => {
    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(updatePropertyForAll(comments, ''))
    }, []);

    return (
        <div>
            <FileHeader />
            <div className="p-3">
                <table className="table table-hover" style={{ fontSize: '13px' }}>
                    <Headers />
                    <Body />
                </table>
            </div>
        </div>
    )
};

export default DrawFile;